import { CardInterface } from '@modules/card/interfaces/card.interface';
import { CardModel } from '@modules/card/models/card.model';

import { SectionType } from '../enums/section-type.enum';

import { Section } from './section.model';

export interface HeroSectionInterface {
  headline?: string;
  anchor?: string;
  teasers: CardInterface[];
  isEqualSection?: boolean;
}

export class HeroSectionModel implements Section {
  public type = SectionType.HERO;
  public teasers: CardModel[];
  public headline?: string;
  public anchor?: string;
  public isEqualSection = false;

  constructor(data: HeroSectionInterface) {
    this.headline = data.headline;
    this.anchor = data.anchor;
    this.teasers = data.teasers.map((teaser) => new CardModel(teaser));
    this.isEqualSection = !!data.isEqualSection;
  }
}
